import { Component } from '@angular/core';
import { PaymentService } from '@services/payment.service';

@Component({
  selector: 'app-trunk-show-report',
  templateUrl: './trunk-show-report.component.html',
  styleUrls: ['./trunk-show-report.component.css'],
})
export class TrunkShowReportComponent {
  rows: any[] = [];
  loading = false;
  startDate = '';
  endDate = '';
  displayedColumns = [
    'name',
    'vendorName',
    'framesSold',
    'grossNewBusiness',
    'discountAmount',
    'salesAfterDiscount',
    'averageSale',
  ];

  constructor(private paymentService: PaymentService) {
    const now = new Date();
    this.startDate = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().slice(0, 10);
    this.endDate = now.toISOString().slice(0, 10);
  }

  load(): void {
    this.loading = true;
    this.paymentService.trunkShowReport(new Date(this.startDate), new Date(this.endDate)).subscribe({
      next: (rows) => {
        this.rows = rows || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  money(value: any): string {
    const n = parseFloat(value);
    if (isNaN(n)) {
      return '0.00';
    }
    return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}
